import React, { Fragment, useState } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { Link } from "react-router";
import Constant from "../../../utils/constant";
import { ClockIcon, HomeIcon, ViewListIcon } from "@heroicons/react/outline";

import { QuestionIcon, StandardIcon, SubjectIcon } from "../../../assets/icons";
import Feedback from "./feedback";

const status = [
  {
    value: 1,
    label: "Open",
  },
  {
    value: 2,
    label: "In-Progress",
  },
  {
    value: 3,
    label: "Hold",
  },
  {
    value: 4,
    label: "Closed",
  },
];

const navigation = [
  { name: "Home", href: "#", icon: HomeIcon, current: true },
  { name: "My tasks", href: "#", icon: ViewListIcon, current: false },
  { name: "Recent", href: "#", icon: ClockIcon, current: false },
];
const teams = [
  { name: "Engineering", href: "#", bgColorClass: "bg-indigo-500" },
  { name: "Human Resources", href: "#", bgColorClass: "bg-green-500" },
  { name: "Customer Success", href: "#", bgColorClass: "bg-yellow-500" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Fragment>
      <div className="px-4 mt-6 sm:px-6 lg:px-8 w-full">
        <Feedback></Feedback>
      </div>
    </Fragment>
  );
}
